export default __webpack_public_path__ + "static/media/LogoHProduce.e3398bf4.svg";